import React, { createContext, useState, useCallback, useContext } from 'react';

export const RefetchContext = createContext({
  triggerRefetch: () => {},
  refetchFlag: false
});

export const RefetchProvider = ({ children }) => {
  const [refetchFlag, setRefetchFlag] = useState(false);

  const triggerRefetch = useCallback(() => {
    setRefetchFlag(prev => !prev);
  }, []);

  return (
    <RefetchContext.Provider value={{ refetchFlag, triggerRefetch }}>
      {children}
    </RefetchContext.Provider>
  );
};

export const useRefetch = () => {
  return useContext(RefetchContext);
};
